export default {
  name: "Message",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M9.5 30c-.61.02-1.12-.6-.98-1.2l.76-3.8H5c-1.16 0-2-.84-2-2V6c0-1.16.84-2 2-2h22c1.16 0 2 .84 2 2v17c0 1.16-.84 2-2 2H16.7c-.26 0-.41.05-.58.18l-6.01 4.61c-.18.14-.39.21-.61.21zM5 6v17h5.5c.3 0 .58.13.77.37s.27.54.21.83L11 26.59l3.89-2.98c.68-.55 1.36-.61 1.81-.61H27V6H5z",
  },
}
